import { io } from 'socket.io-client'





class WhatsappConnection {
  constructor() {
    this.socket = null
    this.sessionUuid = null
  }


  openSocketConection(sessionName) {
    const url = new URL(process.env.MIX_SOCKET_API_URL)

    this.socket = io(`wss://${url.host}/${sessionName}`, {
      'transports': ['websocket']
    })
  }


  onEvent(callback) {
    this.socket.on('connection.update', callback)
  }

  onDisconnect(callback) {
    this.socket.on('disconnect', callback)
  }


  onError(callback) {
    this.socket.on('connect_error', callback)
  }

}



const whatsappConnection = new WhatsappConnection()

export {
  whatsappConnection,
}
